export const COLORS = {
  black: '#211d16',
  primary: '#D2777B',
  green: '#728253',
  clickableArea: '#00000000'
};
